import { render, staticRenderFns } from "./Yr.vue?vue&type=template&id=7f90991f&scoped=true&lang=html&"
import script from "./Yr.vue?vue&type=script&lang=js&"
export * from "./Yr.vue?vue&type=script&lang=js&"
import style0 from "./Yr.vue?vue&type=style&index=0&id=7f90991f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f90991f",
  null
  
)

export default component.exports